import { useEffect, useState } from "react";
import { useAuth } from "../../../context/authProvider";
import { useWatches } from "../../../context/watchProvider";
import { useNavigate } from "react-router-dom";
import LoadingBalls from "../../core/loadingBalls";

export default function MyList() {

    const { userId } = useAuth();
    const { cart, cartUpdated, getCartItems, getCartWatches } = useWatches();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [cartWatches, setCartWatches] = useState<{ [key: string]: string, id: string }[] | null>([]);

    useEffect(() => {
        if (!cartUpdated && userId) {
            getCartItems(userId);
        }
        handleCartWatches();
        // eslint-disable-next-line
    }, [cartUpdated])

    const handleCartWatches = async () => {
        if (!cart?.length) {
            return null;
        }
        setLoading(true);
        const watches = await getCartWatches(cart);
        if (watches?.length) {
            setCartWatches(watches);
        }
        setLoading(false);
    }

    // const doRemoveFromCart = async (watchId: string) => {
    //     if (!userId) {
    //         return null;
    //     }
    //     setLoading(true);
    //     await removeFromCart(userId, watchId);
    //     setLoading(false)
    // }

    return (
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl shadow-primary/5 border border-primary/5 space-y-8 animate-superfade">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="space-y-2">
                    <h2 className="text-2xl font-black text-primary tracking-tight">Minha Lista</h2>
                    <div className="w-12 h-1 bg-secondary" />
                </div>
                {cart?.length ? (
                    <span className="bg-moninho text-primary text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-full">
                        {cartWatches?.length} {cartWatches?.length === 1 ? 'Item' : 'Itens'}
                    </span>
                ) : null}
            </div>

            {
                !cart?.length ?
                    <div className="py-20 text-center space-y-4 bg-moninho/30 rounded-3xl border border-dashed border-primary/10">
                        <p className="text-mono font-medium">Sua lista está vazia no momento.</p>
                        <button
                            onClick={() => navigate('/watches')}
                            className="text-xs font-black tracking-widest text-secondary hover:text-primary transition-colors uppercase"
                        >
                            Explorar Catálogo
                        </button>
                    </div>
                    :
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {
                            loading ?
                                <div className="col-span-full flex justify-center py-20"><LoadingBalls /></div>
                                :
                                cartWatches?.map((w, i) => (
                                    <div
                                        key={i}
                                        className="group bg-white rounded-2xl overflow-hidden border border-primary/5 shadow-sm hover:shadow-xl hover:shadow-primary/5 transition-all duration-500 flex flex-col"
                                    >
                                        <div className="relative aspect-square overflow-hidden cursor-pointer" onClick={() => navigate(`/watches/${w.slug}`)}>
                                            <img src={w.cImgUrl} alt={w.brand} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                                        </div>

                                        <div className="p-4 space-y-3 flex-1 flex flex-col justify-between">
                                            <div>
                                                <p className="text-[10px] font-black text-mono tracking-widest uppercase mb-1">
                                                    {w.brand} | {w.year}
                                                </p>
                                                <p className="text-sm font-bold text-primary group-hover:text-secondary transition-colors line-clamp-1">
                                                    R$ {parseFloat(w.price).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                </p>
                                            </div>

                                            <button
                                                onClick={() => navigate(`/watches/${w.slug}`)}
                                                className="w-full py-2 bg-primary text-secondary font-black tracking-widest text-[9px] rounded-lg hover:bg-primary/95 transition-all active:scale-95 uppercase"
                                            >
                                                Ver Detalhes
                                            </button>
                                        </div>
                                    </div>
                                ))
                        }
                    </div>
            }
        </div>
    )
}